import { Box, GlobalStyles } from '@mui/material';
import { useLayoutEffect, useRef, useState } from 'react';
import { useAuth } from './authContext';
import { BANNER_HEIGHT_VAR } from './bannerOffset';
import { BetaBar } from './BetaBar';
import { ImpersonationBanner } from './ImpersonationBanner';

// Every screen, signed in or not, starts with the beta bar; while a super
// admin is impersonating, the impersonation banner sits above it.
export function TopBars() {
  const { impersonation } = useAuth();
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const impersonating = impersonation !== null;
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => setHeight(el.offsetHeight);
    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [impersonating]);
  return (
    <>
      <GlobalStyles
        styles={{
          ':root': { [BANNER_HEIGHT_VAR]: `${height}px` },
          body: { paddingTop: `var(${BANNER_HEIGHT_VAR})` },
          '@media print': { body: { paddingTop: 0 } },
        }}
      />
      <Box
        ref={ref}
        data-testid="top-bars"
        sx={{ position: 'fixed', left: 0, right: 0, top: 0, zIndex: 1400 }}
      >
        <ImpersonationBanner />
        <BetaBar />
      </Box>
    </>
  );
}
